import React from 'react';

const Slovakia = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46052)">
      <rect width="28" height="20" rx="3" fill="#1A47B8" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 13.3335H28V20.0002H0V13.3335Z" fill="#F93939" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H28V6.66667H0V0ZM13.24 13.3333H13.3333V6.66667H4V13.3333H4.09333C4.032 13.5493 4 13.7733 4 14C4 15.84 8.66667 17.3333 8.66667 17.3333C8.66667 17.3333 13.3333 15.84 13.3333 14C13.3333 13.7733 13.3013 13.5493 13.24 13.3333Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0002 13.3335V5.3335H5.3335V13.3335C5.3335 14.8068 8.66683 16.0002 8.66683 16.0002C8.66683 16.0002 12.0002 14.8068 12.0002 13.3335Z"
        fill="#F93939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10.6665V9.33317H6.66667V7.99984H8V6.6665H9.33333V7.99984H10.6667V9.33317H9.33333V10.6665H11.3333V11.9998H9.33333V13.3332H8V11.9998H6V10.6665H8Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66683 16.0001C8.66683 16.0001 12.0002 14.8068 12.0002 13.3334C12.0002 11.8601 10.6668 12.0001 8.66683 13.3334C6.66683 12.0001 5.3335 11.8601 5.3335 13.3334C5.3335 14.8068 8.66683 16.0001 8.66683 16.0001Z"
        fill="#1A47B8"
      />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46052">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Slovakia;
